import React from 'react';

interface PaymentTabsProps {
  selectedTab: string;
  onTabChange: (tab: string) => void;
  tabs: { [key: string]: string };
}

export const PaymentTabs: React.FC<PaymentTabsProps> = ({ selectedTab, onTabChange, tabs }) => {
  return (
    <div className="tabs mb-4 flex border-b overflow-x-auto">
      {Object.entries(tabs).map(([key, label]) => (
        <button
          key={key}
          className={`flex-1 py-2 px-2 text-center text-xs sm:text-base font-bold min-w-[100px] text-black ${
            selectedTab === key ? `border-b-2` : "text-gray-500"
          }`}
          onClick={() => onTabChange(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}; 